import type { MembershipTierDto } from "../api/hooks/useMembershipTiers";
import type { MembershipCartItem } from "../state/cartStore";

/**
 * For each strategy a membership in the cart includes, the name of that membership. Buying both would pay
 * for the strategy twice, so checkout waits until the strategy goes.
 */
export function includedByMembershipsInCart(
  membershipItems: MembershipCartItem[],
  tiers: MembershipTierDto[] | undefined
): Map<string, string> {
  const includedBy = new Map<string, string>();
  for (const item of membershipItems) {
    const tier = tiers?.find((candidate) => candidate.id === item.tierId);
    for (const strategyId of tier?.tradingStrategyIds ?? []) {
      if (!includedBy.has(strategyId)) {
        includedBy.set(strategyId, item.name);
      }
    }
  }

  return includedBy;
}
